import styled from "styled-components";
import {Button} from "antd";

export const CompleteButton = styled(Button)`
  min-height: unset;
  & span {
    font-size: 12px;
  }
`